<p-tabs [className]="'backgroundLighterGray simple-selector hide-active-bar'" [showNavigators]="false" [scrollable]="false" [value]="view">
    <p-tablist [style]="{ 'overflow': 'hidden !important' }">
        <p-tab [className]="'justify-content-end mr-2'" [value]="'list'"><span class="text-xl pi pi-list"></span></p-tab>
        <p-tab [className]="'justify-content-end'" [value]="'grid'"><span class="text-xl pi pi-th-large"></span></p-tab>
    </p-tablist>
    <br/>
    <p-tabpanels [className]="'backgroundLighterGray'">
        <p-tabpanel class="" [value]="'list'">
            <p-card class="xl-radius">
            <p-table [value]="invoices" [lazy]="true" [lazyLoadOnInit]="true" [totalRecords]="totalCount" [(rows)]="itemsPerPage" [rowsPerPageOptions]="[ 5, 10, 20, 50, 100 ]" (onPage)="pageChange($event)" [sortField]="'startDate'" [sortOrder]="-1" [paginator]="true" [rows]="5" [showCurrentPageReport]="true" [currentPageReportTemplate]="'{totalRecords} facturen'">
                <ng-template #header>
                    <tr>
                        <th>Periode</th>
                        <th>Omschrijving</th>
                        <th>Bedrag</th>
                        <th class="text-align-right">Status</th>
                    </tr>
                </ng-template>
                <ng-template #body let-invoice>
                    <tr (click)="showInvoiceDetail(invoice)" class="cursor-pointer">
                        <td>{{invoice.invoiceDate | date: 'MMMM yyyy'}}</td>
                        <td>{{InvoiceType[invoice.invoiceType]}} {{invoice.invoiceDate | date: 'MMMM yyyy'}}</td>
                        <td>{{invoice.amount | currency: 'EUR'}}</td>
                        <td><p-tag [severity]="getInvoiceStatusClass(getInvoiceStatus(invoice))">{{getInvoiceStatus(invoice)}}</p-tag></td>
                    </tr>
                </ng-template>
            </p-table>
            </p-card>
        </p-tabpanel>
        <p-tabpanel [value]="'grid'">
            @for(key of Object.keys(invoicesGroupedByMonth); track $index) {
                <p-accordion class="xl-radius">
                    <p-accordion-panel [value]="0" [style]="{ 'margin-bottom': '1rem' }">
                        <p-accordion-header [style]="{ 'border-bottom': '1px solid #e0e0e0' }">
                            {{key | date: 'MMMM yyyy'}}
                        </p-accordion-header>
                        <p-accordion-content>
                            @if(invoicesGroupedByMonth[key].length === 0) {
                                <p>Nog geen documenten beschikbaar voor deze maand</p>
                            } @else {
                                <div class="row justify-content-start">
                                @for(invoice of invoicesGroupedByMonth[key]; track $index) {
                                    <invoice-detail-component [invoice]="invoice" [(showInvoiceDetail)]="this.invoiceDetailVisible[invoice.seqVerkoopkop]"></invoice-detail-component>
                                    <p-card (click)="showInvoiceDetail(invoice)" [styleClass]="'backgroundEbemLightestGreenWithBorder'" class="flex xl:col-4 lg:col-4 col-12 mt-4 cursor-pointer">
                                        <div class="row">
                                            <div class="col-2">
                                                <img class="icon-smaller" src="icons/invoices-green-icon.png" />
                                            </div>
                                            <div class="col-10">
                                                <h5 [style]="{ 'margin-block-start': 0, 'margin-block-end': 0}">{{InvoiceType[invoice.invoiceType]}} {{invoice.invoiceDate | date: 'MMMM yyyy'}}</h5>
                                                <p [style]="{ 'margin-block-start': 0, 'margin-block-end': 0 }">{{invoice.invoiceDate | date: 'dd/MM/yyyy'}}</p>
                                                <p [style]="{ 'margin-block-start': 0, 'margin-block-end': 0 }"><p-tag [severity]="getInvoiceStatusClass(getInvoiceStatus(invoice))">{{getInvoiceStatus(invoice)}}</p-tag>&nbsp;{{invoice.amount | currency: 'EUR'}}</p>
                                            </div>
                                        </div>              
                                    </p-card>
                                } 
                                </div>
                            }
                        </p-accordion-content>
                    </p-accordion-panel>
                </p-accordion>
            }
        </p-tabpanel>
    </p-tabpanels>
</p-tabs>
